import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { fetchFonts, installFonts } from 'actions/fonts';

import _ from 'lodash';
import { findFontsFromHTML } from 'components/Editor/helper/widget';
import { Fonts } from '@paperflite-marketing/cleverstory-commons';


export function FontManager(props) {
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(fetchFonts());
  }, [])

  return (
    <Fonts.Manager />
  );
}

export const useFontsFromHtml = (html) => {

  const availableFonts = useSelector(state => _.get(state, 'fonts.items'));
  const [fonts, setFonts] = useState([]);

  useEffect(() => {
    const fontFamilies = findFontsFromHTML(html);
    
    const fonts = fontFamilies.map(name => {
      const font = availableFonts.find(item => item.fontFamily === name);
      return font;
    }).filter(item => item != null)
    .map(font => font.id);

    setFonts(fonts);
  }, [html]);

  
  return fonts;
}